/**
 * Chatbot configuration.
 * The chat API URL points to a Cloudflare Worker that proxies
 * requests through AI Gateway to Workers AI.
 */
export const CHAT_API_URL =
  process.env.REACT_APP_CHAT_API_URL ?? 'http://localhost:8788/chat'
